import MayaTimeout from './MayaTimeout'

export default MayaTimeout
